import {
  Box,
  BoxProps,
  Burger,
  ElementProps,
  Flex,
  Portal,
  Transition,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { HEADER_HEIGHT } from "common/constants";
import { OpenChatButton } from "components/Chat";
import HeaderLogo from "components/HeaderLogo";
import NotificationWidget from "components/NotificationWidget";
import UserAvatar from "components/UserAvatar";
import { motion } from "motion/react";
import { Link } from "react-router";
import { useAuthStore } from "stores/authStore";
import NavigationMenu from "./NavigationMenu/NavigationMenu";

const scaleY = {
  in: { opacity: 1, transform: "scaleY(1)" },
  out: { opacity: 0, transform: "scaleY(0)" },
  common: { transformOrigin: "top" },
  transitionProperty: "transform, opacity",
};

interface HeaderResponsiveProps {
  visible: boolean;
}

const MBox = motion.create(Box<BoxProps & ElementProps<"div", keyof BoxProps>>);

const variants = {
  hidden: { top: -HEADER_HEIGHT },
  visible: { top: 0 },
};

const HeaderResponsive = ({ visible }: HeaderResponsiveProps) => {
  const avatar = useAuthStore(state => state.avatar);
  const fullName = useAuthStore(state => state.fullName);

  const [opened, { toggle, close }] = useDisclosure(false);

  return (
    <MBox
      variants={variants}
      animate={visible ? "visible" : "hidden"}
      transition={{ ease: "easeInOut", duration: 0.15 }}
      px={"sm"}
      className="bg-white shadow-sm flex items-center sticky z-10 w-full"
      component={"header"}
      h={HEADER_HEIGHT}
    >
      <Flex w={"100%"} justify={"space-between"} align={"center"}>
        <Link to="/home" onClick={close}>
          <HeaderLogo />
        </Link>
        <Flex gap={"sm"}>
          <OpenChatButton />

          <NotificationWidget />

          <Box w={40} h={40} visibleFrom="lg">
            <UserAvatar userName={fullName} avatarId={avatar} />
          </Box>

          <Burger
            data-testid="menu-button"
            opened={opened}
            onClick={toggle}
            size={28}
          />

          <Transition transition={scaleY} duration={500} mounted={opened}>
            {style => (
              <Portal target={document.body}>
                <NavigationMenu style={style} toggleMenuIsOpen={toggle} />
              </Portal>
            )}
          </Transition>
        </Flex>
      </Flex>
    </MBox>
  );
};

export default HeaderResponsive;
